// The program is picked, not typed (Satya, 26 Oct): typed programs came back as
// "preschool", "pre school", "Pre-school"... and could not be counted. Must
// match INCIDENT_PROGRAMS in oh_operations/serializers/safeguarding.py.
export const PROGRAMS = [
  'Preschool',
  'Active Care',
  'PTC',
  'After-school',
  'Other'
]

// A child on file carries its class (e.g. "Nursery", "todlr (age 1)"); a
// preschool class means the Preschool program. Anything else is left for the
// team to pick.
export const programForClass = (cls) =>
  /tod|nur|pre|k1|k2|kg|kinder|play/i.test(cls || '') ? 'Preschool' : ''
